import { useAppSelector } from 'app/hooks';
import { selectEditModeData } from 'features/common/editModeSlice';
import { Modal } from 'react-bootstrap';
import { FaSyncAlt } from 'react-icons/fa';
import '../FeatureTitleBar/style.scss';

interface EditModeModalTitleBarProps {
  title: string;
}

function EditModeModalTitleBar({ title }: EditModeModalTitleBarProps) {
  const deliveryId = useAppSelector(selectEditModeData)?.deliveryId;

  return (
    <Modal.Header className={`bg-primary ${deliveryId ? 'justify-content-start' : 'justify-content-center'}`}>
      <Modal.Title className="fs-6 text-white">{title}</Modal.Title>
      {deliveryId && (
        <div className="badge-reedit">
          <div className="badge-reedit-icon">
            <FaSyncAlt size={9} />
          </div>
          <span className="ms-2">再編集モード / 配信No: {deliveryId}</span>
        </div>
      )}
    </Modal.Header>
  );
}

export default EditModeModalTitleBar;
